// src/pages/How.js
import React from "react";
import "../App.css";

function How() {
  return (
    <div style={{ padding: "40px", color: "black" }}>
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>How It Works</h1>
      <p style={{ textAlign: "center", marginBottom: "40px", fontSize: "1.1rem" }}>
        Our chatbots are simple to set up, powerful to use, and designed to save you time.
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <div
          className="card"
          style={{ background: "rgba(27,110,204,0.15)", color: "black" }}
        >
          <h2>Step 1 – Discovery and Data Collection</h2>
          <p>
            We start by understanding your business — identifying the most common
            customer questions. We work with your FAQs, website content, brochures,
            or documents. The chatbot is trained on your data, ensuring accurate,
            brand-specific answers every time.
          </p>
        </div>

        <div
          className="card"
          style={{ background: "rgba(27,110,204,0.25)", color: "black" }}
        >
          <h2>Step 2 – Build</h2>
          <p>
            Once we have your data, we train a custom chatbot using advanced AI. Your
            bot learns your company’s tone and can handle multiple languages if
            needed.
          </p>
        </div>

        <div
          className="card"
          style={{ background: "rgba(27,110,204,0.35)", color: "black" }}
        >
          <h2>Step 3 – Integrate</h2>
          <p>
            You receive a simple embed code or the full chatbot source — ready to plug
            into your website instantly.
          </p>
        </div>

        <div
          className="card"
          style={{ background: "rgba(27,110,204,0.45)", color: "black" }}
        >
          <h2>Step 4 – Smart Support</h2>
          <ul style={{ textAlign: "left", marginTop: "10px" }}>
            <li>✅ Instantly answers customer questions</li>
            <li>✅ Frees your team from repetitive tasks</li>
            <li>✅ Boosts satisfaction with fast responses</li>
            <li>✅ Saves 40–70 staff hours monthly</li>
          </ul>
          <p style={{ marginTop: "10px" }}>
            This isn’t just automation — it’s personalized, intelligent customer
            support available 24/7.
          </p>
        </div>
      </div>

      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <a
          href="https://www.fiverr.com/s/vv2aNBA"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            style={{
              padding: "12px 25px",
              border: "2px solid white",
              borderRadius: "8px",
              background: "transparent",
              color: "black",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Get Started Now
          </button>
        </a>
      </div>
    </div>
  );
}

export default How;